//#region Libraries
import styled from "styled-components";
//#endregion
import { TDefContent } from "components/CustomTableList/components/TableListItem/ListItem/styles";

export const Cell = styled(TDefContent)`
    width: 100%;
    &.small {
        padding: 10px 15px;
    }
    & h5 {
        width: max-content;
        width: 100%;
        text-align: center;
    }
    &.changed h5 {
        font-weight: bold;
    }
`;